var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.197 10.587a.667.667 0 0 0 0 .943l.943.943c.26.26.682.26.943 0L8 6.555l5.918 5.918c.26.26.683.26.943 0l.943-.943a.667.667 0 0 0 0-.943l-7.33-7.33A.665.665 0 0 0 8 3.062a.665.665 0 0 0-.472.195l-7.33 7.33z",
    fill: "currentColor"
  })));
};

export default SvgChevron;